module.exports = __webpack_public_path__ + "static/img/layout-left-shadow.78702f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/layout-left-shadow.png
// module id = fxOi
// module chunks = 0